import regex from 'services/regex';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const asyncValidate = (values) => {
    return sleep(0)
        .then(() => {
            let _errors = {};
            let required = [
                'name',
            ];

            required.map((r) => {
                if (app._.isEmpty(values[r])) {
                    _errors[r] = app.translate('main.This field is required');
                }
            });

            if (values['name'] && !regex.persianAndLatin.test(values['name'])) {
                _errors['name'] = app.translate('routes.home.basic.personnel.name is not valid');
            }

            if (!app._.isEmpty(_errors)) {
                throw _errors;
            } else {
                return Promise.resolve('Sign up is broken now!');
            }
        });
};

export default asyncValidate;
